<template>
  <div id="consultas-pre-natal" class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="true"
        :callbackOnChangeProfissional="onChangeProfissional"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      ></selects>
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
        <b-tab title="Lista" active @click="buscarDadosDaLista()">
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setRed="setRed"
                      @resetarNome="setRed = false"
                    ></Subtitle>
                  </div>
                  <div class="select-situacao info-table-item">
                    <vue-select
                      :options="situacao_opcoes"
                      label="situacao"
                      placeholder="Situação"
                      v-model="situacao"
                      @input="
                        situacao !== null
                          ? filtros(
                              exibirCadastrosVermelhos,
                              exibirCadastrosVerdes,
                              $event
                            )
                          : filtros(
                              exibirCadastrosVermelhos,
                              exibirCadastrosVerdes,
                              { situacao: 'Todos' }
                            )
                      "
                      :clearable="true"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.situacao }}
                      </template>
                      <div slot="no-options">Não há opções correspondentes</div>
                    </vue-select>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="pre-natal"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loadingLista"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Resultado" @click="buscarDadosDoResultado()">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-lg-12">
              <div class="resultado-consultas-pre-natal">
                <b-tabs
                  id="tabs-2"
                  key="tabs-2"
                  fill
                  class="esus-feedback-tabs"
                  v-model="tabsActive2"
                >
                  <b-tab title="resultado" active>
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Tabela"
                        class="icon-tooltip icofont-table"
                      ></i>
                    </template>
                  </b-tab>
                  <b-tab title="grafico">
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Gráfico"
                        class="icon-tooltip icofont-chart-bar-graph"
                      ></i>
                    </template>
                  </b-tab>
                </b-tabs>
              </div>
              <tabela-secretaria
                v-if="tabsActive2 === 0"
                :por_municipio_gestantes_estimadas="
                  por_municipio_gestantes_estimadas
                "
                :por_municipio_gestantes_informadas="
                  por_municipio_gestantes_informadas
                "
                :por_municipio_pre_natal="por_municipio_pre_natal"
                :por_municipio_resultado="por_municipio_resultado"
                :por_equipe_gestantes_estimadas="por_equipe_gestantes_estimadas"
                :por_equipe_gestantes_informadas="
                  por_equipe_gestantes_informadas
                "
                :por_equipe_pre_natal="por_equipe_pre_natal"
                :por_equipe_resultado="por_equipe_resultado"
                :secretaria_municipal_de_saude_no_acs_denominador="
                  parseInt(secretaria_municipal_de_saude_no_acs_denominador)
                "
                :secretaria_municipal_de_saude_no_acs_numerador="
                  parseInt(secretaria_municipal_de_saude_no_acs_numerador)
                "
                :secretaria_municipal_de_saude_no_acs_resultado="
                  parseInt(secretaria_municipal_de_saude_no_acs_resultado)
                "
                :secretaria_municipal_de_saude_no_municipio_meta="
                  secretaria_municipal_de_saude_no_municipio_meta
                "
                :secretaria_municipal_de_saude_na_equipe_meta="
                  secretaria_municipal_de_saude_na_equipe_meta
                "
                :secretaria_municipal_de_saude_no_acs_meta="
                  secretaria_municipal_de_saude_no_acs_meta
                "
                :loading="loadingResultado"
                :cod_ibge="$store.state.cod_ibge"
                v-on:update:resultadoMunicipio="resultado_no_municipio = $event"
              >
              </tabela-secretaria>
              <div v-if="tabsActive2 === 1">
                <secretaria-grafico
                  :arrayChartMunicipio="arrayChartMunicipio"
                  :arrayChartEquipe="arrayChartEquipe"
                  :arrayChartAcs="arrayChartAcs"
                  :temEquipe="temEquipe"
                  :temAcs="temAcs"
                  :no_municipio_estimadas="
                    parseInt(por_municipio_gestantes_estimadas)
                  "
                  :no_municipio_informadas="
                    parseInt(por_municipio_gestantes_informadas)
                  "
                  :no_municipio_numerador="parseInt(por_municipio_pre_natal)"
                  :no_municipio_resultado="parseInt(por_municipio_resultado)"
                  :na_equipe_estimadas="
                    parseInt(por_equipe_gestantes_estimadas)
                  "
                  :na_equipe_informadas="
                    parseInt(por_equipe_gestantes_informadas)
                  "
                  :na_equipe_numerador="parseInt(por_equipe_pre_natal)"
                  :na_equipe_resultado="parseInt(por_equipe_resultado)"
                  :no_acs_informadas="
                    parseInt(secretaria_municipal_de_saude_no_acs_denominador)
                  "
                  :no_acs_numerador="
                    parseInt(secretaria_municipal_de_saude_no_acs_numerador)
                  "
                  :no_acs_resultado="
                    parseInt(secretaria_municipal_de_saude_no_acs_resultado)
                  "
                >
                </secretaria-grafico>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Gráfico" @click="buscarDadosDoGrafico()">
          <pulse-loader
            :loading="loadingGrafico"
            :color="color"
            :size="size"
            class="vue-loader"
          ></pulse-loader>
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Gráfico
          </template>
          <div class="row">
            <div class="col-lg-12">
              <div class="box">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-chart-bar-graph"></i> Série Histórica
                  </h4>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <apexchart
                        type="line"
                        height="350"
                        :options="chartOptions"
                        :series="chartData"
                        ref="chartData"
                      ></apexchart>
                      <tabela-serie-historica
                        :xaxis="xaxis"
                        :chartOptions="chartOptions"
                        :arrayChartMunicipio="arrayChartMunicipio"
                        :arrayChartEquipe="arrayChartEquipe"
                        :arrayChartAcs="arrayChartAcs"
                        :equipe="equipe"
                        :profissional="profissional"
                      />
                      <p class="fonte">
                        <b>Fonte:</b> e-SUS PEC, {{ data_dados_chart }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Subtitle from './Subtitle'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions'
import TabelaSecretaria from './TabelaSecretaria.vue'
import SecretariaGrafico from './SecretariaGrafico.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import { chartOptions, dataFields, infoHtml } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import tabelaSerieHistorica from '@/components/tabelaSerieHistorica'
import Selects from '@/components/utils/Selects.vue'

export default {
  name: 'ConsultasPreNatalPorEquipeAcs',
  components: {
    PulseLoader,
    Subtitle,
    Loader,
    apexchart: VueApexCharts,
    'tabela-secretaria': TabelaSecretaria,
    'secretaria-grafico': SecretariaGrafico,
    TabelaCadastros,
    DownloadFiles,
    tabelaSerieHistorica,
    Selects,
  },
  mixins: [utils],

  data() {
    return {
      tabsActive: 0,
      tabsActive2: 0,
      temEquipe: false,
      temAcs: false,
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      loadingResultado: false,
      loadingLista: false,
      loadingGrafico: false,
      size: '40px',
      color: '#0D98BB',
      por_municipio_gestantes_estimadas: 0,
      por_municipio_gestantes_informadas: 0,
      por_municipio_pre_natal: 0,
      por_municipio_resultado: 0,
      por_equipe_gestantes_estimadas: 0,
      por_equipe_gestantes_informadas: 0,
      por_equipe_pre_natal: 0,
      por_equipe_resultado: 0,
      resultado_no_municipio: '',
      resultado_na_equipe: '',
      secretaria_municipal_de_saude_no_acs_numerador: 0,
      secretaria_municipal_de_saude_no_acs_denominador: 0,
      secretaria_municipal_de_saude_no_acs_resultado: 0,
      secretaria_municipal_de_saude_no_municipio_meta: 0,
      secretaria_municipal_de_saude_na_equipe_meta: 0,
      secretaria_municipal_de_saude_no_acs_meta: 0,
      nomeEquipe: '',
      nomeProfissional: '',
      arrayChartMunicipio: [],
      arrayChartEquipe: null,
      arrayChartAcs: null,
      data_dados_chart: '',
      xaxis: [],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      micro_areas: [],
      micro_area: '',
      dadosDoResultado: [],
      dataFields: {
        ...dataFields,
      },
      situacao_opcoes: [
        {
          situacao: 'Todos',
        },
        {
          situacao: 'Auto referido',
        },
        {
          situacao: '1º Trimestre',
        },
        {
          situacao: '2º Trimestre',
        },
        {
          situacao: '3º Trimestre',
        },
        {
          situacao: 'Denominador',
        },
      ],
      situacao: '',
      cadastrosOriginais: [],
      setRed: false,
      text: infoHtml,
      equipeEvent: '',
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde, situacao) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      // Se null setar como vazio
      if (situacao === null) {
        this.situacao = ''
        situacao = ''
      }
      if (situacao !== '') {
        data = this.handleSituacao(data, situacao)
      }
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },

    handleSituacao(data, event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      const situacao = event.situacao
      let filtrado = data.filter((item) => {
        if (situacao === 'Todos') {
          return item
        }
        if (situacao === 'Auto referido') {
          return item.dt_atendimento === null
        } else if (situacao === '1º Trimestre') {
          return Number(item.trimestre) == 1
        } else if (situacao === '2º Trimestre') {
          return Number(item.trimestre) == 2
        } else if (situacao === '3º Trimestre') {
          return Number(item.trimestre) == 3
        } else if (situacao === 'Denominador') {
          return Number(item.denominador) == 1
        } else {
          return item
        }
      })

      return filtrado
    },
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false, this.situacao)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false, this.situacao)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true, this.situacao)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false, this.situacao)
        this.exibirCadastrosVerdes = false
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipeEvent = event
        this.situacao = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.profissionais = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = event.nu_ine
        this.nomeEquipe = event.no_equipe
        if (event.nu_ine != 'sem-equipe') {
          this.buscarCadastrosIndividuaisTodosPorEquipe()
        } else {
          this.profissional = ''
          this.nomeProfissional = ''
          this.profissional = ''
          this.profissionais = []
          this.buscarCadastrosIndividuaisSemEquipe()
        }
      } else {
        this.equipeEvent = ''
        this.temEquipe = false
        this.temAcs = false
        this.profissionais = []
        this.profissional = ''
        this.situacao = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.micro_area = ''
        this.micro_areas = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''
        this.nomeEquipe = ''

        return
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.situacao = ''
        this.profissional = event?.nu_cpf
        this.nomeProfissional = event?.no_profissional
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.buscarDadosDaLista()
      } else {
        this.situacao = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.temAcs = false
        this.profissional = ''
        this.nomeProfissional = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.onChangeEquipe(this.equipeEvent)
        return
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.situacao = ''
        this.loadingLista = true
        this.nomeProfissional = ''
        this.profissional = ''
        this.micro_area = event?.micro_area
        this.tabsActive = 0
        this.tabsActive2 = 0
        if (this.micro_area == undefined) {
          this.tabsActive = 0
          this.tabsActive2 = 0
        }
        if (this.micro_area !== undefined) {
          let response = await Functions.getCadastrosIndividuaisPorMicroArea(
            this.cod_ibge,
            this.equipe,
            this.micro_area
          )
          if (response) {
            this.cadastrosOriginais = response
            this.cadastros = response
            this.tabsActive = 0
            this.filtros(true, false, this.situacao)
            this.setRed = true
            this.loadingLista = false
          }
        }
      } else {
        this.cadastrosOriginais = []
        this.cadastros = []
        this.situacao = ''
        this.nomeProfissional = ''
        this.profissional = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.onChangeEquipe(this.equipeEvent)
      }
    },

    async buscarDadosDoResultado() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.temEquipe = false
      this.temAcs = false
      this.tabsActive2 = 0
      this.por_equipe_gestantes_estimadas = 0
      this.por_equipe_gestantes_informadas = 0
      this.por_equipe_pre_natal = 0
      this.por_equipe_resultado = 0
      this.secretaria_municipal_de_saude_no_acs_numerador = 0
      this.secretaria_municipal_de_saude_no_acs_denominador = 0
      this.secretaria_municipal_de_saude_no_acs_resultado = 0
      this.secretaria_municipal_de_saude_no_municipio_meta = 0
      this.secretaria_municipal_de_saude_na_equipe_meta = 0
      this.secretaria_municipal_de_saude_no_acs_meta = 0
      this.loadingResultado = true
      try {
        if (this.dadosDoResultado.length === 0) {
          // busca os dados
          let response = await this.$api.get(
            '/app/indicadores-aps/resultado/' + this.cod_ibge + '/1'
          )
          if (response) {
            this.dadosDoResultado = response.data
          }
        }
        // Pega série histórica do municipio
        if (this.arrayChartMunicipio.length === 0) {
          await this.carregarSerieHistorica()
        }
        // dados do município
        const dadosDoMunicipio = this.dadosDoResultado.find((item) => {
          return item.ibge_ine === 'MUN'
        })
        this.por_municipio_gestantes_estimadas = dadosDoMunicipio.estimativa
        this.por_municipio_gestantes_informadas = dadosDoMunicipio.denominador
        this.por_municipio_pre_natal = dadosDoMunicipio.numerador
        this.por_municipio_resultado = dadosDoMunicipio.resultado
        if (parseInt(this.por_municipio_resultado) > 100) {
          this.por_municipio_resultado = 100
        }

        // dados da equipe
        if (
          this.equipe !== '' &&
          this.equipe !== null &&
          this.equipe !== 'sem-equipe'
        ) {
          let equipe = await this.$api.get(
            '/app/equipe/' + this.cod_ibge + '/' + this.equipe
          )
          if (equipe) {
            // Pega série histórica da equipe
            if (this.arrayChartEquipe === null) {
              await this.carregarSerieHistoricaPorEquipe(equipe.data.nu_ine)
            }

            const dadosDaEquipe = this.dadosDoResultado.find((item) => {
              return item.ibge_ine === equipe.data.nu_ine
            })
            this.temEquipe = true
            this.por_equipe_gestantes_estimadas = dadosDaEquipe.estimativa
            this.por_equipe_gestantes_informadas = dadosDaEquipe.denominador
            this.por_equipe_pre_natal = dadosDaEquipe.numerador
            this.por_equipe_resultado = dadosDaEquipe.resultado
          }
        } else {
          this.temEquipe = false
          this.temAcs = false
        }

        // dados do acs
        if (
          this.profissional !== '' &&
          this.profissional !== null &&
          this.profissional !== 'todos'
        ) {
          const profissional = await this.$api.get(
            '/app/profissional/' + this.profissional + '/' + this.cod_ibge
          )
          if (profissional) {
            this.nomeProfissional = profissional.data.no_profissional
            const dadosDoAcs = this.dadosDoResultado.find((item) => {
              return item.ibge_ine === profissional.data.nu_cpf
            })

            if (dadosDoAcs !== undefined) {
              // Pega série histórica do profissional
              if (this.arrayChartAcs === null) {
                await this.carregarSerieHistoricaAcs()
              }

              this.temAcs = true
              this.secretaria_municipal_de_saude_no_acs_denominador =
                dadosDoAcs.denominador
              this.secretaria_municipal_de_saude_no_acs_numerador =
                dadosDoAcs.numerador
              this.secretaria_municipal_de_saude_no_acs_resultado =
                dadosDoAcs.resultado
              if (this.secretaria_municipal_de_saude_no_acs_resultado > 100) {
                this.secretaria_municipal_de_saude_no_acs_resultado = 100
              }
            }
          }
        } else {
          this.temAcs = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingResultado = false
      }
    },

    // busca os dados de acordo com os valores do select
    async buscarDadosDaLista() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (this.profissional !== '' && this.profissional !== null) {
        this.loadingLista = true
        try {
          if (
            this.profissional !== 'sem-acs' &&
            this.profissional !== 'todos'
          ) {
            const profissional = await this.$api.get(
              '/app/profissional/' + this.profissional + '/' + this.cod_ibge
            )
            let response = await Functions.getCadastrosIndividuais(
              this.cod_ibge,
              profissional.data.nu_cpf
            )
            if (response) {
              this.cadastrosOriginais = response
              this.cadastros = response
              this.filtros(true, false, this.situacao)
              this.setRed = true
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      }
    },

    async buscarCadastrosIndividuaisSemEquipe() {
      this.loadingLista = true
      let response = await Functions.getCadastrosIndividuaisSemEquipe(
        this.cod_ibge
      )
      if (response) {
        this.cadastrosOriginais = response
        this.cadastros = response
        this.filtros(true, false, this.situacao)
        this.setRed = true
        this.loadingLista = false
      }
    },

    async buscarCadastrosIndividuaisTodosPorEquipe() {
      this.loadingLista = true
      let response = await Functions.getCadastrosIndividuaisTodosPorEquipe(
        this.cod_ibge,
        this.equipe
      )
      if (response) {
        this.cadastrosOriginais = response
        this.cadastros = response
        this.filtros(true, false, this.situacao)
        this.setRed = true
        this.loadingLista = false
      }
    },

    async buscarDadosDoGrafico() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.loadingGrafico = true
      if (this.arrayChartMunicipio.length === 0) {
        await this.carregarSerieHistorica()
      }
      if (this.equipe !== '') {
        //pega a equipe do acs
        let equipe = await this.$api.get(
          '/app/equipe/' + this.cod_ibge + '/' + this.equipe
        )
        if (equipe) {
          this.nomeEquipe = equipe.data.no_equipe
          await this.carregarSerieHistoricaPorEquipe(equipe.data.nu_ine)
          this.loadingGrafico = false
        }

        if (this.profissional !== '') {
          // Pega a série histórica do acs
          await this.carregarSerieHistoricaAcs()
        }
      }
      this.loadingGrafico = false
    },

    async carregarSerieHistorica() {
      this.$api
        .get('/app/serie-historica/municipio/' + this.cod_ibge + '/1')
        .then((response) => {
          let array_chart_municipio = []
          let array_xaxis = []
          //carregar eixo x
          for (let i = 0; i < response.data.length; i++) {
            array_xaxis.push(response.data[i].mes_ano)
            this.xaxis.push(response.data[i].mes_ano)
          }
          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis,
            },
          })
          // carregar dados do município
          for (let i = 0; i < response.data.length; i++) {
            array_chart_municipio.push(response.data[i].resultado)
          }
          this.$refs.chartData.updateSeries([
            {
              name: 'Município',
              data: array_chart_municipio,
            },
          ])
          this.arrayChartMunicipio = array_chart_municipio
          this.data_dados_chart = this.formatDate(
            response.data[response.data.length - 1].data_dados
          )
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    async carregarSerieHistoricaPorEquipe(nu_ine) {
      let array_chart_equipe = await Functions.carregarSerieHistoricaPorEquipe(
        this.cod_ibge,
        nu_ine,
        this.xaxis
      )

      this.arrayChartEquipe = array_chart_equipe

      this.$refs.chartData.updateSeries([
        {
          name: 'MUNICÍPIO',
          data: this.arrayChartMunicipio,
        },
        {
          name: this.nomeEquipe,
          data: array_chart_equipe,
        },
      ])
    },

    async carregarSerieHistoricaAcs() {
      let arrayChartAcs = await Functions.carregarSerieHistoricaPorAcs(
        this.cod_ibge,
        this.profissional,
        this.xaxis
      )

      if (arrayChartAcs !== null) {
        this.arrayChartAcs = arrayChartAcs
        this.$refs.chartData.updateSeries([
          {
            name: 'MUNICÍPIO',
            data: this.arrayChartMunicipio,
          },
          {
            name: this.nomeEquipe,
            data: this.arrayChartEquipe,
          },
          {
            name: 'ACS',
            data: arrayChartAcs,
          },
        ])
      } else {
        this.arrayChartAcs = null
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipeEvent,
        this.profissional,
        this.nomeProfissional
      )
    },
  },
  created() {},
}
</script>

<style scoped>
.tabela {
  margin: 0px auto;
  margin-bottom: 16px;
}

th,
td {
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #e8e8e8;
}
td:first-child {
  border-top: unset;
  border-right: unset;
}
th:first-child {
  border-top: unset;
  border-left: unset;
}
.barrinha {
  width: 35px;
  height: 5px;
  display: block;
  border-radius: 10px;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}
.titulo_td {
  display: flex;
  align-items: center;
  gap: 5px;
}
.sem-borda {
}
thead {
  border-top: unset;
  border-left: unset;
}
</style>
<style>
.select-situacao {
  margin: 10px;
  min-width: 210px;
}
@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
}
</style>
<style>
#consultas-pre-natal .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#consultas-pre-natal .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#consultas-pre-natal .select-situacao .v-select {
  width: 296px;
}
#consultas-pre-natal .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
<style>
.resultado-consultas-pre-natal {
  cursor: pointer;
  display: flex;
  padding: 10px 1rem;
  gap: 15px;
  font-size: 20px;
  color: black;
  background: white;
  justify-content: flex-end;
  padding-bottom: 5px;
}
.resultado-consultas-pre-natal .esus-feedback-tabs ul li .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}
.resultado-consultas-pre-natal .esus-feedback-tabs ul {
  background: #0fafd726;
  border-radius: 5px;
  padding: 0px 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resultado-consultas-pre-natal .esus-feedback-tabs ul li .nav-link.active {
  transition: all ease 0.3s;
  border-color: unset !important;
  border-bottom: unset;
  border: unset;
}
.resultado-consultas-pre-natal
  .esus-feedback-tabs
  ul
  li:first-child
  .nav-link.active {
  background-color: #0056b3 !important;
  color: white !important;
  border-radius: 5px 0px 0px 5px;
  animation: left 0.5s ease 0s 1 normal forwards;
}
.resultado-consultas-pre-natal
  .esus-feedback-tabs
  ul
  li:last-child
  .nav-link.active {
  background-color: #0056b3 !important;
  color: white !important;
  border-radius: 0px 5px 5px 0px;
  animation: right 0.5s ease 0s 1 normal forwards;
}
.resultado-consultas-pre-natal .nav-tabs {
  border-bottom: unset;
}
@keyframes right {
  0% {
    transform: translateX(-40px);
  }

  100% {
    transform: translateX(0px);
  }
}
@keyframes left {
  0% {
    transform: translateX(40px);
  }

  100% {
    transform: translateX(0px);
  }
}
</style>
